export default "__VITE_ASSET__BJVOngXJ__"